/**
 * Librería de utilidades para gráficos con Chart.js
 *
 */
/* global Chart */
export const CIFRA_COLOR_SCHEMES = {
  RojosClaritos: [
    ...Chart.colorschemes.brewer.Reds9.slice(1),
    '#960018',
    '#B22222',
  ],
  Estandar: [
    ...Chart.colorschemes.brewer.RdYlGn11.slice(0),
    '#fe1d12',
    '#f8ac59',
  ],
};

export const CIFRA_BORDER_COLORS = CIFRA_COLOR_SCHEMES.RojosClaritos;

export const CIFRA_BACKGROUND_COLORS = CIFRA_BORDER_COLORS.map((color) => (
  Chart.helpers.color(color).alpha(0.5).rgbString()
));

const COLOR_WARNING = '#f8ac59';
const COLOR_DANGER = '#ed5565';
const COLOR_SUCCESS = '#70b173';

const VALOR_NOTA_COLOR = {
  '🟢': COLOR_SUCCESS,
  '🟠': COLOR_WARNING,
  '🔴': COLOR_DANGER,
  '😃': COLOR_SUCCESS,
  '😡': COLOR_DANGER,
};

export const getColoresTipoNota = (tipoNota) => {
  let coloresBase = CIFRA_COLOR_SCHEMES.Estandar;
  if (tipoNota.opciones?.length) {
    coloresBase = tipoNota.opciones.map((opcion, index) => (
      VALOR_NOTA_COLOR[opcion.valor]
        || CIFRA_COLOR_SCHEMES.RojosClaritos[index]
    ));
  }

  return {
    border: coloresBase,
    background: coloresBase.map((color) => Chart.helpers.color(color).alpha(0.2).rgbString()),
  };
};
